<template>
  <div>
    <goods-list v-show="tabType === 1" @handleShow="handleShow" :isIntegral="0" />
    <goods-show v-if="tabType === 2" :rowItem="rowItem" :goodsType="1" @handleShow="handleShow" />
  </div>
</template>

<script>
import goodsList from './list.vue'
import goodsShow from './show.vue'
export default {
  components: { goodsList, goodsShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>